<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="editTool">
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteTool">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editTool: function() {
      this.params.context.componentParent.editTool(this.params.data);
    },
    deleteTool: function() {
      this.params.context.componentParent.deleteTool(this.params.data);
    }
  }
};
</script>
